<mat-card class="card-style-full px-6 py-6 pt-0">
  <mat-card-header class="flex justify-between items-center gap-2">
    <div class="flex-1 flex items-center gap-3">
      <mat-card-title class="">Criar nova proposta</mat-card-title>
      @if (draftStatus === 'saving') {
        <span class="flex items-center gap-1 text-sm text-gray-500">
          <mat-spinner diameter="14"></mat-spinner> Salvando...
        </span>
      } @else if (draftStatus === 'saved') {
        <span class="flex items-center gap-1 text-sm text-green-600">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px"
            >cloud_done</mat-icon
          >
          Rascunho salvo
        </span>
      }
    </div>
    <button mat-flat-button class="btn-tg-cancel w-1/12" (click)="close()">
      Cancelar
    </button>
    <button
      mat-flat-button
      class="btn-tg w-1/12"
      [disabled]="!checkForm()"
      (click)="createProposalClient()"
    >
      @if (loading) {
        <mat-spinner diameter="22" class="loading-spinner"></mat-spinner>
      } @else {
        Cadastrar
      }
    </button>
  </mat-card-header>
  <div class="my-4"></div>
  <div>
    <mat-accordion multi>
      <mat-expansion-panel expanded>
        <mat-expansion-panel-header>
          <mat-panel-title> <h4>Proposta</h4> </mat-panel-title>
        </mat-expansion-panel-header>
        <div>
          <div [formGroup]="form" class="mt-4 container mx-auto">
            <div class="flex justify-between items-center mt-3 -mx-2">
              <mat-form-field class="input-tg w-3/12 px-2" appearance="outline">
                <mat-label>Status Proposta</mat-label>
                <mat-select formControlName="statusProposal">
                  @for (type of ListProposalStatus; track type) {
                    <mat-option [value]="type.id">{{
                      type.descricao
                    }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <!--    </div>-->

              <!--    <div class="flex justify-between items-center mt-3 -mx-2">-->
              <mat-form-field class="input-tg w-3/12 px-2" appearance="outline">
                <mat-label>Nome evento</mat-label>
                <input matInput formControlName="eventName" />
              </mat-form-field>

              <mat-form-field class="input-tg w-3/12 px-2" appearance="outline">
                <mat-label>Data inicio</mat-label>
                <input
                  matInput
                  [matDatepicker]="dateStart"
                  (focus)="openDatepicker('dateStart')"
                  [max]="form.get('dateEnd')?.value"
                  formControlName="dateStart"
                  readonly
                />
                <mat-datepicker-toggle
                  matIconSuffix
                  [for]="dateStart"
                ></mat-datepicker-toggle>
                <mat-datepicker #dateStart></mat-datepicker>
              </mat-form-field>
              <mat-form-field class="input-tg w-3/12 px-2" appearance="outline">
                <mat-label>Data fim</mat-label>
                <input
                  matInput
                  [matDatepicker]="dateEnd"
                  (focus)="openDatepicker('dateEnd')"
                  formControlName="dateEnd"
                  [min]="form.get('dateStart')?.value"
                  readonly
                />
                <mat-datepicker-toggle
                  matIconSuffix
                  [for]="dateEnd"
                ></mat-datepicker-toggle>
                <mat-datepicker #dateEnd></mat-datepicker>
              </mat-form-field>

              <!--      <div class="w-4/12 px-2">-->
              <!--        <div class="box-form">-->
              <!--          <h4>Inicio evento</h4>-->
              <!--          <div class="input-box flex justify-between items-center w-full">-->
              <!--            <mat-form-field-->
              <!--              class="input-tg w-9/12 px-2 no-message-new"-->
              <!--              appearance="outline"-->
              <!--            >-->
              <!--              <mat-label>Data</mat-label>-->
              <!--              <input-->
              <!--                matInput-->
              <!--                [matDatepicker]="dateStart"-->
              <!--                (focus)="openDatepicker('dateStart')"-->
              <!--                formControlName="dateStart"-->
              <!--                readonly-->
              <!--              />-->
              <!--              <mat-datepicker-toggle-->
              <!--                matIconSuffix-->
              <!--                [for]="dateStart"-->
              <!--              ></mat-datepicker-toggle>-->
              <!--              <mat-datepicker #dateStart></mat-datepicker>-->
              <!--            </mat-form-field>-->

              <!--            <mat-form-field-->
              <!--              class="input-tg w-3/12 px-2 no-message-new"-->
              <!--              appearance="outline"-->
              <!--            >-->
              <!--              <mat-label>Hora (24h)</mat-label>-->
              <!--              <input matInput type="time" formControlName="timeStart" />-->
              <!--            </mat-form-field>-->
              <!--          </div>-->
              <!--        </div>-->
              <!--      </div>-->
              <!--      <div class="w-4/12 px-2">-->
              <!--        <div class="box-form">-->
              <!--          <h4>Final evento</h4>-->
              <!--          <div class="input-box flex justify-between items-center w-full">-->
              <!--            <mat-form-field-->
              <!--              class="input-tg w-9/12 px-2 no-message-new"-->
              <!--              appearance="outline"-->
              <!--            >-->
              <!--              <mat-label>Data</mat-label>-->
              <!--              <input-->
              <!--                matInput-->
              <!--                [matDatepicker]="dateEnd"-->
              <!--                (focus)="openDatepicker('dateEnd')"-->
              <!--                formControlName="dateEnd"-->
              <!--                readonly-->
              <!--              />-->
              <!--              <mat-datepicker-toggle-->
              <!--                matIconSuffix-->
              <!--                [for]="dateEnd"-->
              <!--              ></mat-datepicker-toggle>-->
              <!--              <mat-datepicker #dateEnd></mat-datepicker>-->
              <!--            </mat-form-field>-->
              <!--            <mat-form-field-->
              <!--              class="input-tg w-3/12 px-2 no-message-new"-->
              <!--              appearance="outline"-->
              <!--            >-->
              <!--              <mat-label>Hora (24h)</mat-label>-->
              <!--              <input matInput type="time" formControlName="timeEnd" />-->
              <!--            </mat-form-field>-->
              <!--          </div>-->
              <!--        </div>-->
              <!--      </div>-->
            </div>

            <div class="flex justify-between items-center mt-3 -mx-2">
              <mat-form-field class="input-tg w-8/12 px-2" appearance="outline">
                <mat-label>Cliente</mat-label>
                <input matInput formControlName="client" readonly />
                @if (this.form.get('client')!.enabled) {
                  <button mat-icon-button matSuffix (click)="addClient()">
                    <mat-icon>add</mat-icon>
                  </button>
                }
              </mat-form-field>
              <mat-form-field class="input-tg w-8/12 px-2" appearance="outline">
                <mat-label>Subcliente</mat-label>
                <input matInput formControlName="subClient" readonly />
                @if (this.form.get('subClient')!.enabled) {
                  <button mat-icon-button matSuffix (click)="addSubClient()">
                    <mat-icon>add</mat-icon>
                  </button>
                }
              </mat-form-field>
              <mat-form-field class="input-tg w-8/12 px-2" appearance="outline">
                <mat-label>Consultor Cliente</mat-label>
                <input matInput formControlName="consultant" readonly />
                @if (this.form.get('consultant')!.enabled) {
                  <button
                    mat-icon-button
                    matSuffix
                    (click)="addConsultantClient()"
                  >
                    <mat-icon>add</mat-icon>
                  </button>
                }
              </mat-form-field>
              <mat-form-field class="input-tg w-8/12 px-2" appearance="outline">
                <mat-label>Consultor Comercial</mat-label>
                <input matInput formControlName="employeeConsultant" readonly />
                @if (this.form.get('employeeConsultant')!.enabled) {
                  <button
                    mat-icon-button
                    matSuffix
                    (click)="addEmployeeConsultant()"
                  >
                    <mat-icon>add</mat-icon>
                  </button>
                }
              </mat-form-field>
            </div>

            <div class="flex justify-start items-center mt-3 -mx-2">
              <mat-form-field class="input-tg w-2/12 px-2" appearance="outline">
                <mat-label>Quant. passageiros</mat-label>
                <input matInput formControlName="numPassengers" integerInput />
              </mat-form-field>

              <mat-form-field class="input-tg w-3/12 px-2" appearance="outline">
                <mat-label>Forma/prazo de pagamento</mat-label>
                <mat-select formControlName="paymentMethod">
                  @for (type of ListPaymentMethods; track type) {
                    <mat-option [value]="type.id">
                      <span class="text-xs">{{ type.prazo }}</span
                      ><br />
                      <span class="text-sm">{{ type.tipoPagamento }}</span>
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <!--      <mat-form-field class="input-tg w-3/12 px-2" appearance="outline">-->
              <!--        <mat-label>Taxa Serviço</mat-label>-->
              <!--        @if (form.get('serviceFee')!.value != '') {-->
              <!--          <span matTextSuffix>%&nbsp;</span>-->
              <!--        }-->
              <!--        <input-->
              <!--          matInput-->
              <!--          formControlName="serviceFee"-->
              <!--          currencyInput-->
              <!--          (blur)="updateGrandTotal()"-->
              <!--        />-->
              <!--      </mat-form-field>-->
            </div>

            <div class="w-full my-4">
              <div class="box-form">
                <h4 class="bg-gray">Solicitante</h4>
                <div class="input-box flex flex-col items-center w-full">
                  <!--                  <div class="flex justify-between items-center -mx-2 w-full">-->
                  <!--                    <mat-form-field-->
                  <!--                      class="input-tg w-full px-2"-->
                  <!--                      appearance="outline"-->
                  <!--                    >-->
                  <!--                      <mat-label>Responsáveis</mat-label>-->
                  <!--                      <mat-select-->
                  <!--                        formControlName="responsible"-->
                  <!--                        (selectionChange)="fillResponsible()"-->
                  <!--                      >-->
                  <!--                        @for (item of ListResponsible; track item) {-->
                  <!--                          <mat-option [value]="item">-->
                  <!--                            <span class="text-sm"-->
                  <!--                              >Nome: {{ item.nome }} | Email: {{ item.email }} |-->
                  <!--                              Telefone: {{ item.telefone }}</span-->
                  <!--                            >-->
                  <!--                          </mat-option>-->
                  <!--                        }-->
                  <!--                      </mat-select>-->
                  <!--                    </mat-form-field>-->
                  <!--                  </div>-->
                  <div class="flex justify-between items-center -mx-2 w-full">
                    <mat-form-field
                      class="input-tg w-4/12 px-2 no-message-new"
                      appearance="outline"
                    >
                      <mat-label>Nome</mat-label>
                      <input
                        matInput
                        formControlName="requesterName"
                        readonly
                      />
                    </mat-form-field>

                    <mat-form-field
                      class="input-tg w-4/12 px-2 no-message-new"
                      appearance="outline"
                    >
                      <mat-label>Email</mat-label>
                      <input
                        matInput
                        formControlName="requesterEmail"
                        readonly
                      />
                    </mat-form-field>

                    <mat-form-field
                      class="input-tg w-4/12 px-2 no-message-new"
                      appearance="outline"
                    >
                      <mat-label>Telefone</mat-label>
                      <input
                        matInput
                        formControlName="requesterPhone"
                        [mask]="'(99) 99999-9999'"
                        readonly
                      />
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>

            <div class="flex justify-end items-center mt-4 mb-6 -mx-2">
              <!--              <div class="w-9/12 px-2">-->
              <!--                <div class="box-form">-->
              <!--                  <h4>Comissão | Divisor | Taxa</h4>-->
              <!--                  <div-->
              <!--                    class="input-box flex justify-between items-center w-full"-->
              <!--                  >-->
              <!--                    <mat-form-field-->
              <!--                      class="input-tg w-3/12 px-2 no-message-new"-->
              <!--                      appearance="outline"-->
              <!--                    >-->
              <!--                      <mat-label>Tipo</mat-label>-->
              <!--                      <mat-select-->
              <!--                        formControlName="typeCommission"-->
              <!--                        (selectionChange)="onSelectionChangeType($event)"-->
              <!--                      >-->
              <!--                        @for (type of ListCommission; track type) {-->
              <!--                          <mat-option-->
              <!--                            [value]="type.value"-->
              <!--                            [disabled]="type.disabled"-->
              <!--                          >-->
              <!--                            {{ type.description }}-->
              <!--                          </mat-option>-->
              <!--                        }-->
              <!--                      </mat-select>-->
              <!--                    </mat-form-field>-->
              <!--                    <mat-form-field-->
              <!--                      class="input-tg w-3/12 px-2 no-message-new"-->
              <!--                      appearance="outline"-->
              <!--                    >-->
              <!--                      <mat-label>Comissão</mat-label>-->
              <!--                      @if (form.get('commission')!.value != '') {-->
              <!--                        <span matTextSuffix>%&nbsp;</span>-->
              <!--                      }-->
              <!--                      <input-->
              <!--                        matInput-->
              <!--                        formControlName="commission"-->
              <!--                        decimalInput-->
              <!--                      />-->
              <!--                    </mat-form-field>-->
              <!--                    <mat-form-field-->
              <!--                      class="input-tg w-3/12 px-2 no-message-new"-->
              <!--                      appearance="outline"-->
              <!--                    >-->
              <!--                      <mat-label>Divisor</mat-label>-->
              <!--                      <input matInput formControlName="divider" decimalInput />-->
              <!--                    </mat-form-field>-->
              <!--                    <mat-form-field-->
              <!--                      class="input-tg w-3/12 px-2 no-message-new"-->
              <!--                      appearance="outline"-->
              <!--                    >-->
              <!--                      <mat-label>Taxa</mat-label>-->
              <!--                      @if (form.get('tax')!.value != '') {-->
              <!--                        <span matTextSuffix>%&nbsp;</span>-->
              <!--                      }-->
              <!--                      <input matInput formControlName="tax" currencyInput />-->
              <!--                    </mat-form-field>-->
              <!--                  </div>-->
              <!--                </div>-->
              <!--              </div>-->
              <mat-form-field
                class="input-tg w-3/12 px-2 no-message-new"
                appearance="outline"
              >
                <mat-label>Total Geral</mat-label>
                @if (form.get('grandTotal')!.value != '') {
                  <span matTextPrefix>R$&nbsp;</span>
                }
                <input matInput formControlName="grandTotal" currencyInput />
              </mat-form-field>
            </div>
          </div>
        </div>
      </mat-expansion-panel>
      <mat-expansion-panel expanded>
        <mat-expansion-panel-header>
          <mat-panel-title> <h4>Itens proposta</h4> </mat-panel-title>
        </mat-expansion-panel-header>
        <div>
          <item-proposal-replicate
            [idClient]="idClient"
            [listItemsProposal]="ListItemsProposalReplicate"
            [period]="getPeriod()"
            (response)="getList($event)"
          />
        </div>
      </mat-expansion-panel>
      <mat-expansion-panel expanded>
        <mat-expansion-panel-header>
          <mat-panel-title> <h4>Serviços adicionais</h4> </mat-panel-title>
        </mat-expansion-panel-header>
        <div>
          <service-additional-proposal-create
            [period]="getPeriod()"
            [listServiceAdditional]="listServiceAdditionalReplicate"
            (response)="getListServiceAdditional($event)"
          />
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</mat-card>
